import { render, staticRenderFns } from "./Ortodoncia.vue?vue&type=template&id=3d806a00&scoped=true&"
import script from "./Ortodoncia.vue?vue&type=script&lang=ts&"
export * from "./Ortodoncia.vue?vue&type=script&lang=ts&"
import style0 from "./Ortodoncia.vue?vue&type=style&index=0&id=3d806a00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d806a00",
  null
  
)

export default component.exports